import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ingestApi } from "../../../api";
import { SourceOrgCategory } from "../../../generated/ingest-api";

export function useDeleteSource(category: SourceOrgCategory, orgId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sourceId: string) =>
      ingestApi.deleteSource(category, sourceId, { org_id: orgId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["listSources", category, orgId],
      });
    },
  });
}
